module.exports = __webpack_public_path__ + "img/ring_r_0_null_null@3x.1efea890.png";